<template>
  <div class="component-actions">
    <slot name="actionMenu"></slot>
    <div class="listing-title">{{ title }}</div>
    <div class="spacer" />
    <slot name="actionButtons"></slot>
  </div>
</template>

<script>
export default {
  name: 'ComponentActions',
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.component-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;

  .spacer {
    flex-grow: 1;
  }

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
  }
}
</style>
